import React from "react"
import { Grid } from "@mui/material"
import { DrawerSeeker } from "@ui-seeker/core"

import { isEditUserSettingsOfficesGroupDrawer, isOpenUserSettingsOfficesGroupDrawer, userSettingsOfficesGroupFormData } from "../../@signals"
import UserSettingOfficesGroupDrawerName from "./Name"
import UserSettingOfficesGroupDrawerOffices from "./Offices"
import UserSettingOfficesGroupDrawerSubmit from "./Submit"


export default function UserSettingOfficesGroupDrawer() {

	return <DrawerSeeker
		hideActions
		title={isEditUserSettingsOfficesGroupDrawer.value ? 'Edit office group' : 'New office group'}
		isOpen={isOpenUserSettingsOfficesGroupDrawer.value}
		controller={() => userSettingsOfficesGroupFormData.value = { }}
	>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<UserSettingOfficesGroupDrawerName />
			</Grid>

			<Grid item xs={12}>
				<UserSettingOfficesGroupDrawerOffices />
			</Grid>

			<Grid item xs={12} sx={{  display: 'flex', justifyContent: 'flex-end'  }}>
				<UserSettingOfficesGroupDrawerSubmit />
			</Grid>
		</Grid>
	</DrawerSeeker>
}